export const PLAY_STORE_LINK =
  'https://play.google.com/store/apps/details?id=br.net.sumicity.central'

export const APP_STORE_LINK =
  'https://apps.apple.com/br/app/giga-fibra-central-do-cliente/id1234351006'
